import { BrowserRouter as Router } from 'react-router-dom';
import AppRouter from './router/AppRouter';
import './styles/Main.css';

function Main() {
  return (
    <Router>
      {/* <NavBar /> */}
      <AppRouter />
      {/* <Footer /> */}
    </Router>
  );
}

export default Main;
